import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded'
import { BottomSheet } from '../Common/BottomSheet'
import { Pressable } from '../Common/Pressable'
import type { PulseReportKind } from '../../types/pulseReport'
import { PULSE_REPORT_KIND_COST, PULSE_REPORT_KIND_LABEL } from '../../types/pulseReport'

const REPORT_KINDS: PulseReportKind[] = ['SNAPSHOT', 'RISK', 'BUDGET', 'DIGEST', 'GOVERNANCE']

const REPORT_KIND_COPY: Record<PulseReportKind, string> = {
  SNAPSHOT: 'Full health, risks, budget, activity, and next-read summary.',
  RISK: 'Open project risks, failed automation signals, and stock pressure.',
  BUDGET: 'Budget utilization, over-budget count, and stock cost pressure.',
  DIGEST: 'Recent activity digest written as a readable update.',
  GOVERNANCE: 'Audit-led operational narrative for review and accountability.',
}

export const PulseReportRunSheet = ({
  open,
  walletCredits,
  runningKind,
  onRun,
  onClose,
}: {
  open: boolean
  walletCredits: number
  runningKind: PulseReportKind | null
  onRun: (kind: PulseReportKind) => void
  onClose: () => void
}) => {
  return (
    <BottomSheet isOpen={open} onClose={onClose} title="Generate report">
      <div className="pulseReportRunSheet__list">
        {REPORT_KINDS.map((kind) => {
          const cost = PULSE_REPORT_KIND_COST[kind]
          const disabled = runningKind !== null || walletCredits < cost
          const isPrimary = kind === 'SNAPSHOT'
          return (
            <Pressable
              key={kind}
              disabled={disabled}
              onClick={() => onRun(kind)}
              className={isPrimary ? 'isPrimary' : undefined}
              aria-pressed={isPrimary}
            >
              <PlayArrowRoundedIcon fontSize="small" />
              <span>
                <strong>{PULSE_REPORT_KIND_LABEL[kind]}</strong>
                <small>{REPORT_KIND_COPY[kind]}</small>
              </span>
              <em>{cost} Cr</em>
            </Pressable>
          )
        })}
      </div>
    </BottomSheet>
  )
}
